export default __webpack_public_path__ + "static/media/usergroup.b6d3ddd7.svg";